// extracted by mini-css-extract-plugin
export default {"circles":"circles--xWQnZ","circle":"circle--B66Z4","animated":"animated--NExMv"};